import React from "react";
import spaceImg1 from "../../assets/Capabilities.png";
import spaceImg2 from "../../assets/Established.png";
import spaceImg3 from "../../assets/HomeImage.png";

export const OurSpace = () => {
    return (
        <section className="w-full bg-white py-10 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 space-y-6">

                <div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
                        Our Space
                    </h2>
                    <p className="mt-3 text-gray-600">
                        Where we plan, design, and manage every project
                    </p>
                </div>

                {/* Scrolling Row */}
                <div className="relative overflow-hidden">
                    <div className="flex gap-6 animate-scroll">

                        {[spaceImg1, spaceImg2, spaceImg3, spaceImg1, spaceImg2, spaceImg3].map((img, i) => (
                            <div key={i} className="min-w-[300px]">
                                <img
                                    src={img}
                                    alt="workspace"
                                    className="w-full h-72 object-cover rounded-xl shadow-md"
                                />
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>
    );
};